import * as React from "react";
import { Mutation, MutationFn } from "react-apollo";
import {
  UpsertUserMutation,
  UpsertUserMutationVariables
} from "../../__generated__/types";
import { UPDATE_USER_QUERY } from "./queries";
import { USER_QUERY } from "../../queries/ProfileQuery/queries";
import { USER_QUERY as USER_ID_QUERY } from "../../screens/User/queries";
import { ALL_USERS_QUERY } from "src/queries/UsersQuery/queries";

class UpdateMutation extends Mutation<
  UpsertUserMutation,
  UpsertUserMutationVariables
> {}

export type UpdateUserFn = MutationFn<
  UpsertUserMutation,
  UpsertUserMutationVariables
>;

export interface Props {
  refetchAll?: boolean;
  userId?: string;
  children(props: UpdateUserFn): JSX.Element | null;
}

export interface State {}

export default class UpsertUser extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <UpdateMutation
        mutation={UPDATE_USER_QUERY}
        refetchQueries={[
          this.props.userId
            ? this.props.refetchAll
              ? { query: USER_ID_QUERY, variables: { id: this.props.userId } }
              : { query: USER_QUERY }
            : { query: ALL_USERS_QUERY }
        ]}
        awaitRefetchQueries={true}
      >
        {update => {
          return this.props.children(update);
        }}
      </UpdateMutation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mutations/UpdateUser/UpsertUser.tsx